{
  "close": "Закрыть",
  "notifications": "{count, plural, one {# уведомление} other {# уведомления}}."
}
